"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _Language = _interopRequireDefault(require("@mui/icons-material/Language"));
var _Menu = _interopRequireDefault(require("common-components/dist/common/components/Menu"));
function getTopMenu(props) {
  var _data$settings, _data$settings$basic_;
  var context = props.context,
    appContext = props.appContext,
    externalContext = props.externalContext,
    postContext = props.postContext,
    artworkContext = props.artworkContext;
  var labels = appContext.labels;
  var data = artworkContext.data,
    configuration = artworkContext.configuration;
  var post = postContext.post;
  var _externalContext$exte = externalContext.externalSettings,
    externalSettings = _externalContext$exte === void 0 ? {} : _externalContext$exte;
  var showConfiguration = post === null || post === void 0 ? void 0 : post._id;
  if (!showConfiguration) {
    return null;
  }
  var languages = ((_data$settings = data.settings) === null || _data$settings === void 0 ? void 0 : (_data$settings$basic_ = _data$settings.basic_settings) === null || _data$settings$basic_ === void 0 ? void 0 : _data$settings$basic_.languages) || [];
  var selectedLang = configuration.selectedLang;
  return [].concat((0, _toConsumableArray2["default"])(languages.length && languages.length > 1 ? [{
    featured: true,
    Element: function Element() {
      return /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
        MoreIcon: _Language["default"],
        menu: (0, _toConsumableArray2["default"])(languages.map(function (lang) {
          return {
            name: labels.languages && labels.languages[lang] || lang,
            onClick: function onClick(e) {
              e.preventDefault();
              context.res.wappResponse.store.dispatch(context.wapp.states.runAction("req", {
                name: "timestamp",
                value: Date.now()
              }));
              artworkContext.setConfiguration((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, configuration), {}, {
                selectedLang: lang
              }));
            },
            className: function className(_ref) {
              var style = _ref.style;
              return lang === selectedLang ? style.selectedMenu : null;
            }
          };
        }))
      });
    }
  }] : []), (0, _toConsumableArray2["default"])(externalSettings.getTopMenu ? externalSettings.getTopMenu(props) : []));
}
var _default = getTopMenu;
exports["default"] = _default;